
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punetonavimumbaicab() {



const cardData = {
  keyword: "Pune to Navi Mumbai Cab   ",
  heading: "Skyline Cabs: Pune to Navi Mumbai Cab   ",
  headingDescription: "Skyline Cabs provides reliable and professionally managed Pune to Navi Mumbai Cab services for corporate travelers, IT professionals, families, and long-distance airport passengers. Whether you are traveling from central Pune, Kharadi, Baner, Hadapsar, or Pimpri-Chinchwad, we ensure smooth expressway connectivity to Navi Mumbai International Airport. Our fleet includes well-maintained AC sedans, SUVs, and premium vehicles suitable for luggage-friendly long-distance travel. With experienced chauffeurs, punctual pickup scheduling, transparent fare structure, and 24x7 availability, Skyline Cabs ensures safe, stress-free, and on-time transfers from Pune to Navi Mumbai.",

  top: "Top Places to visit in Navi Mumbai with skyline Cab",

 topPlaces: [
  {
    title: "Palm Beach Road",
    description: "Palm Beach Road is one of the most scenic stretches in Navi Mumbai offering wide lanes, sea views, and smooth connectivity between Vashi, Nerul, and Belapur. Travelers heading toward Chhatrapati Shivaji Maharaj International Airport or Navi Mumbai International Airport enjoy this peaceful coastal drive. The well-planned infrastructure and skyline views make it ideal for business and residential access."
  },
  {
    title: "Central Park Kharghar",
    description: "Central Park in Kharghar is one of the largest urban parks in India, offering jogging tracks, musical fountains, gardens, and open green spaces. It is a perfect relaxation spot for families and professionals looking to unwind after travel or work commitments."
  },
  {
    title: "Pandavkada Waterfalls",
    description: "Pandavkada Waterfalls in Kharghar is a popular monsoon attraction known for its natural beauty and serene surroundings. Visitors from across Mumbai and nearby areas come here for short weekend trips and scenic photography."
  },
  {
    title: "Seawoods Grand Central Mall",
    description: "Seawoods Grand Central Mall is a premium shopping and entertainment destination featuring international brands, fine dining restaurants, and multiplex cinemas. Its proximity to major railway stations and business hubs makes it a convenient stop for travelers."
  },
  {
    title: "Nerul Balaji Temple",
    description: "Nerul Balaji Temple is a beautifully designed hilltop temple inspired by the Tirupati Balaji Temple. It offers peaceful surroundings, impressive architecture, and panoramic city views, attracting devotees and tourists alike."
  },
  {
    title: "Belapur Fort",
    description: "Belapur Fort is a historic structure built during the 16th century, offering trekking trails and scenic views of the surrounding creek areas. It is a favorite destination for history enthusiasts and adventure seekers."
  },
  {
    title: "DY Patil Stadium",
    description: "DY Patil Stadium in Nerul is a world-class sports venue that hosts IPL matches, concerts, and major events. Its modern infrastructure makes it one of the prominent landmarks in Navi Mumbai."
  },
  {
    title: "Kharghar Hills",
    description: "Kharghar Hills is a popular trekking and sunrise viewpoint destination offering panoramic views of Navi Mumbai. Nature lovers and fitness enthusiasts frequently visit for early morning hikes."
  },
  {
    title: "Wonders Park Nerul",
    description: "Wonders Park in Nerul is a family-friendly attraction featuring miniature replicas of the Seven Wonders of the World along with landscaped gardens and play areas for children."
  },
  {
    title: "Vashi Creek",
    description: "Vashi Creek is known for its beautiful sunset views and peaceful waterfront atmosphere. It serves as a scenic gateway connecting Mumbai and Navi Mumbai, attracting photographers and evening walkers."
  }
],

services: [
  {
    name: "Pune to Navi Mumbai Cab",
    description: "Skyline Cabs provides reliable Pune to Navi Mumbai Cab service designed for smooth and comfortable intercity travel via Pune–Mumbai expressway connectivity. Our fleet includes well-maintained, air-conditioned sedans and SUVs suitable for business trips, airport transfers, and family travel with adequate luggage capacity. Professional chauffeurs monitor highway traffic conditions and select optimized routes to ensure timely arrival without unnecessary delays. We focus on structured pickup coordination from any Pune location and maintain disciplined long-distance driving standards. Transparent pricing, advance booking confirmation, and safe travel management guarantee a dependable cab service experience."
  },
  {
    name: "Navi Mumbai to Pune Cab",
    description: "Navi Mumbai to Pune Cab service ensures seamless return intercity travel with professional chauffeur support and comfortable vehicles. Skyline Cabs provides clean and sanitized cars optimized for long-route expressway performance and passenger convenience. Drivers plan departure timing based on traffic flow and peak-hour conditions across Navi Mumbai zones. We coordinate pickup from residential, commercial, and airport areas with punctual scheduling. Transparent fare structure and structured booking management ensure reliable and stress-free connectivity."
  },
  {
    name: "Navi Mumbai to Pune Taxi",
    description: "Navi Mumbai to Pune Taxi service offers dependable highway connectivity supported by experienced long-distance drivers. Vehicles are air-conditioned, spacious, and maintained for smooth intercity travel between major city hubs. Chauffeurs monitor expressway traffic updates and adjust routing to maintain efficient travel timing. We provide organized pickup coordination with punctual departure planning. Clear pricing policies and professional driving standards ensure consistent and secure taxi services."
  },
  {
    name: "Navi Mumbai to Pune Taxi Fare",
    description: "Navi Mumbai to Pune Taxi Fare service provides transparent and competitive pricing with no hidden charges. Skyline Cabs offers clear fare breakdown based on vehicle category and travel requirements for accurate cost estimation. Our structured billing policies include one-way and round-trip options tailored to passenger convenience. Drivers maintain disciplined travel standards and optimized routing for efficient expressway connectivity. Reliable service execution and clear communication guarantee trustworthy intercity travel."
  },
  {
    name: "Pune to Navi Mumbai Taxi",
    description: "Pune to Navi Mumbai Taxi service delivers comfortable and punctual intercity transfers supported by professional chauffeurs and maintained vehicles. Skyline Cabs ensures convenient pickup from residential, corporate, and industrial areas across Pune. Drivers carefully manage departure timing to avoid congestion and maintain smooth expressway transit. Our vehicles provide comfortable seating and adequate luggage space for long-distance journeys. Transparent pricing and structured coordination ensure dependable taxi connectivity."
  },
  {
    name: "Pune to Navi Mumbai Cabs",
    description: "Pune to Navi Mumbai Cabs service offers multiple vehicle options including sedan, SUV, and premium categories suitable for varied travel needs. Skyline Cabs ensures each vehicle undergoes regular maintenance checks for safe and smooth highway performance. Professional drivers monitor traffic conditions and select optimized routes for timely arrival. We provide structured booking confirmation and punctual pickup scheduling. Transparent fare policies and safety-focused service standards ensure reliable intercity travel."
  },
  {
    name: "Cab from Pune to Navi Mumbai",
    description: "Cab from Pune to Navi Mumbai service provides efficient and comfortable long-distance connectivity with experienced chauffeurs. Skyline Cabs ensures punctual pickup from any Pune locality with optimized highway route planning. Vehicles are air-conditioned and suitable for smooth expressway travel with adequate luggage capacity. Traffic monitoring and disciplined departure scheduling guarantee timely arrival. Transparent pricing and structured service coordination deliver consistent travel quality."
  },
  {
    name: "Taxi from Pune to Navi Mumbai",
    description: "Taxi from Pune to Navi Mumbai service offers reliable intercity transfers with professional driving standards and passenger comfort focus. Skyline Cabs provides sanitized and well-maintained vehicles designed for highway travel efficiency. Drivers coordinate departure timing carefully to avoid delays caused by city congestion. We ensure smooth routing through expressway corridors for uninterrupted transit. Transparent billing structure and secure service execution guarantee dependable taxi travel."
  },
  {
    name: "Hadapsar to Navi Mumbai Cab",
    description: "Hadapsar to Navi Mumbai Cab service ensures smooth intercity connectivity with structured pickup coordination from residential and commercial areas. Skyline Cabs provides comfortable vehicles optimized for long-distance expressway travel with sufficient baggage space. Drivers monitor traffic updates near Hadapsar and select efficient departure timing. We maintain disciplined highway driving standards for safe transit. Transparent pricing and punctual service management ensure reliable cab solutions."
  },
  {
    name: "Hinjewadi to Navi Mumbai Cab",
    description: "Hinjewadi to Navi Mumbai Cab service offers dependable intercity transfers tailored for IT professionals and corporate travelers. Skyline Cabs ensures timely pickup from Hinjewadi phases and Rajiv Gandhi Infotech Park areas. Vehicles are well-maintained and designed for smooth expressway connectivity. Drivers optimize routing based on highway traffic conditions for punctual arrival. Transparent fare policies and structured booking management guarantee professional service delivery."
  },
  {
    name: "Wakad to Navi Mumbai Cab",
    description: "Wakad to Navi Mumbai Cab service delivers comfortable and efficient intercity travel with professional chauffeur support. Skyline Cabs coordinates punctual pickup from Wakad residential and commercial hubs. Vehicles are air-conditioned and maintained for long-distance highway performance. Traffic monitoring and strategic departure scheduling ensure smooth transit. Transparent pricing and disciplined driving standards provide consistent travel reliability."
  },
  {
    name: "Baner to Navi Mumbai Cab",
    description: "Baner to Navi Mumbai Cab service ensures reliable intercity connectivity supported by experienced drivers and optimized route planning. Skyline Cabs provides clean and spacious vehicles suitable for comfortable highway travel. Departure timing is planned carefully to avoid congestion across Baner and expressway entry points. We focus on punctual arrival and structured booking confirmation. Transparent fare structure and safety-focused management ensure dependable service."
  },
  {
    name: "Kharadi to Navi Mumbai Cab",
    description: "Kharadi to Navi Mumbai Cab service offers smooth and secure expressway travel with professional chauffeur coordination. Skyline Cabs ensures timely pickup from residential complexes and corporate parks in Kharadi. Vehicles are optimized for long-distance comfort and sufficient luggage accommodation. Drivers monitor traffic flow to maintain efficient routing. Transparent pricing and disciplined service standards guarantee reliable connectivity."
  },
  {
    name: "Pimpri Chinchwad to Navi Mumbai Cab",
    description: "Pimpri Chinchwad to Navi Mumbai Cab service provides dependable intercity transfers with punctual pickup scheduling and safe highway travel. Skyline Cabs offers air-conditioned vehicles designed for smooth long-distance connectivity. Drivers plan departures considering PCMC traffic patterns and expressway conditions. We ensure timely arrival and structured booking management. Transparent billing and consistent service execution maintain travel reliability."
  },
  {
    name: "Innova Crysta Pune to Navi Mumbai",
    description: "Innova Crysta Pune to Navi Mumbai service offers premium and spacious travel suitable for families and corporate executives. The vehicle ensures superior seating comfort, enhanced luggage capacity, and stable expressway performance. Professional chauffeurs coordinate punctual departure and optimized routing. Travel schedules are aligned for smooth intercity connectivity. Transparent pricing and structured booking management ensure premium service quality."
  },
  {
    name: "Ertiga Cab Pune to Navi Mumbai",
    description: "Ertiga Cab Pune to Navi Mumbai service delivers economical yet comfortable intercity travel for small groups and business passengers. The vehicle provides balanced seating comfort and sufficient luggage space for highway connectivity. Drivers monitor traffic conditions and manage departure timing strategically. We ensure punctual arrival and safe long-distance transit. Transparent fare structure and disciplined service standards guarantee dependable travel."
  },
  {
    name: "Sedan Cab Pune to Navi Mumbai",
    description: "Sedan Cab Pune to Navi Mumbai service offers cost-effective and reliable intercity transportation with comfortable air-conditioned seating. Skyline Cabs ensures timely pickup and optimized highway routing for smooth travel. Drivers carefully manage departure timing to avoid traffic congestion. Vehicles are maintained for efficient long-distance performance. Transparent billing policies and structured coordination ensure consistent service quality."
  },
  {
    name: "SUV Cab Pune to Navi Mumbai",
    description: "SUV Cab Pune to Navi Mumbai service provides spacious and comfortable intercity travel ideal for families and group passengers. Vehicles offer higher seating comfort, ample luggage capacity, and stable expressway performance. Professional chauffeurs monitor traffic updates and adjust routing accordingly. Departure scheduling ensures punctual arrival at the destination. Transparent pricing and disciplined driving standards ensure dependable SUV connectivity."
  },
  {
    name: "Pune to Navi Mumbai One Way Cab",
    description: "Pune to Navi Mumbai One Way Cab service offers economical fixed-rate travel without return fare charges. Skyline Cabs ensures punctual pickup from any Pune locality with optimized highway navigation. Vehicles are clean, comfortable, and suitable for smooth long-distance connectivity. Drivers carefully coordinate departure timing to maintain punctual arrival. Transparent billing structure and professional service management guarantee reliable one-way transfers."
  },
  {
    name: "Pune to Navi Mumbai Drop Taxi",
    description: "Pune to Navi Mumbai Drop Taxi service ensures efficient one-way intercity travel with structured pickup coordination and safe highway driving standards. Skyline Cabs provides comfortable vehicles optimized for expressway connectivity. Drivers monitor traffic conditions and adjust routing to maintain smooth transit. We focus on punctual arrival and professional service execution. Transparent fare policies and consistent travel management guarantee dependable drop taxi solutions."
  }
],

tableData: [
  ["Pune to Navi Mumbai Cab", "Navi Mumbai to Pune Cab"],
  ["Navi Mumbai to Pune Taxi", "Navi Mumbai to Pune Taxi Fare"],
  ["Pune to Navi Mumbai Taxi", "Pune to Navi Mumbai Cabs"],
  ["Cab from Pune to Navi Mumbai", "Taxi from Pune to Navi Mumbai"],
  ["Hadapsar to Navi Mumbai Cab", "Hinjewadi to Navi Mumbai Cab"],
  ["Wakad to Navi Mumbai Cab", "Baner to Navi Mumbai Cab"],
  ["Kharadi to Navi Mumbai Cab", "Pimpri Chinchwad to Navi Mumbai Cab"],
  ["Innova Crysta Pune to Navi Mumbai", "Ertiga Cab Pune to Navi Mumbai"],
  ["Sedan Cab Pune to Navi Mumbai", "SUV Cab Pune to Navi Mumbai"],
  ["Pune to Navi Mumbai One Way Cab", "Pune to Navi Mumbai Drop Taxi"]
],

whychoose: [
  {
    WhyChooseheading: "Pune City Pickup Expertise",
    WhyChoosedescription: "Skyline Cab drivers have extensive knowledge of Pune city roads, traffic hotspots, and peak-hour congestion zones, including areas like Koregaon Park, Kalyani Nagar, and Swargate. This local expertise allows them to plan the fastest and most efficient route for your journey to Navi Mumbai, minimizing delays and ensuring a smooth start to your airport transfer or intercity trip. Real-time traffic monitoring ensures a stress-free departure every time."
  },
  {
    WhyChooseheading: "Pune–Mumbai Expressway Proficiency",
    WhyChoosedescription: "Our chauffeurs are highly experienced with long-distance expressway driving, particularly on the Pune–Mumbai Expressway. They maintain safe speeds, smooth handling, and proper lane discipline throughout the journey. Familiarity with toll plazas, highway diversions, and traffic patterns ensures Skyline Cab provides a comfortable and secure transfer, making your Pune to Navi Mumbai ride hassle-free and punctual."
  },
  {
    WhyChooseheading: "Punctual and Reliable Service",
    WhyChoosedescription: "Skyline Cab prioritizes timely pickups and arrivals, whether for airport transfers or intercity travel. We calculate travel times carefully, factoring in traffic, route options, and drop-off requirements to guarantee you reach Navi Mumbai safely and on schedule. Our commitment to punctuality ensures you can plan your journey with confidence, avoiding the stress of last-minute delays."
  },
  {
    WhyChooseheading: "Transparent and Fair Pricing",
    WhyChoosedescription: "Our fare structure is completely transparent for Pune to Navi Mumbai trips, including toll charges, driver allowance, and applicable taxes, with no hidden fees. Customers receive clear pricing upfront, allowing them to budget their travel without surprises. This transparency builds trust and makes Skyline Cab a reliable choice for intercity transfers and airport commutes alike."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Skyline Cab operates round-the-clock, ensuring availability for early morning, late-night, or emergency rides. Our 24/7 customer support coordinates bookings, driver details, and real-time updates, making it easy for passengers to schedule trips from Pune to Navi Mumbai at any time of day or night without worry."
  },
  {
    WhyChooseheading: "Comfortable and Sanitized AC Vehicles",
    WhyChoosedescription: "We provide a fleet of clean, air-conditioned cars equipped for long-distance travel. Spacious interiors and well-maintained seating ensure comfort throughout the journey. Regular sanitation practices and vehicle inspections guarantee a hygienic and safe environment for families, solo travelers, and corporate clients alike during transfers from Pune to Navi Mumbai."
  },
  {
    WhyChooseheading: "Corporate and Family-Friendly Travel",
    WhyChoosedescription: "Skyline Cab caters to both business and personal travelers, providing professional, courteous drivers who assist with luggage and ensure a comfortable ride. Executives traveling to meetings or flights, as well as families on leisure trips, can rely on our service for smooth, timely, and pleasant intercity transfers."
  },
  {
    WhyChooseheading: "Dedicated Customer Support",
    WhyChoosedescription: "Our support team stays actively involved from booking to drop-off, providing driver details, live updates, and responsive assistance for any changes. Skyline Cab emphasizes customer satisfaction by ensuring each Pune to Navi Mumbai trip is seamless, stress-free, and enjoyable, making us a trusted choice for intercity travel."
  }
]


}

const faqData = [
    {
        id: 1,
        question: 'How can I book Hadapsar to Navi Mumbai Airport Cab with Skyline Cabs?',
        answer:
            'Booking Hadapsar to Navi Mumbai Airport Cab with Skyline Cabs is simple, fast, and reliable. You can visit our website or mobile app, enter Hadapsar as your pickup location and Navi Mumbai Airport as your drop destination, select your preferred vehicle, and confirm instantly. After booking, you receive complete trip confirmation along with driver and vehicle details. Our streamlined booking system ensures a smooth airport transfer experience without last-minute hassle.',
    },
    {
        id: 2,
        question: 'Is Hadapsar to Navi Mumbai Airport Cab service available 24/7?',
        answer:
            'Yes, Skyline Cabs provides 24/7 Hadapsar to Navi Mumbai Airport Cab service for both early morning and late-night flights. Whether you are traveling from Magarpatta, Amanora, or nearby areas in Hadapsar, our professional drivers ensure punctual pickup and timely airport drop. We understand the importance of flight schedules and guarantee reliable airport transfers at any hour.',
    },
    {
        id: 3,
        question: 'What vehicle options are available for Hadapsar to Navi Mumbai Airport Cab?',
        answer:
            'We offer multiple vehicle options including Swift Dzire, Ertiga, Innova Crysta, and premium SUVs for Hadapsar to Navi Mumbai Airport Cab bookings. You can choose a budget-friendly sedan for solo travel or a spacious SUV for family and group transfers. All vehicles are well-maintained, sanitized, air-conditioned, and driven by experienced chauffeurs for maximum comfort.',
    },
    {
        id: 4,
        question: 'How much is the Hadapsar to Navi Mumbai Airport Cab fare?',
        answer:
            'The Hadapsar to Navi Mumbai Airport Cab fare depends on the vehicle type and travel date. Skyline Cabs follows a transparent pricing policy where the total fare is shown before booking confirmation. The price includes driver allowance and applicable charges, ensuring there are no hidden costs or surprise payments.',
    },
    {
        id: 5,
        question: 'Is one-way Hadapsar to Navi Mumbai Airport Cab available?',
        answer:
            'Yes, Skyline Cabs offers affordable one-way Hadapsar to Navi Mumbai Airport Cab service. You only pay for the distance traveled without return fare charges. This makes it convenient and economical for airport drops and single-direction travel needs.',
    },
    {
        id: 6,
        question: 'How long does it take to travel from Hadapsar to Navi Mumbai Airport by cab?',
        answer:
            'The journey from Hadapsar to Navi Mumbai Airport typically takes around 2.5 to 3.5 hours depending on traffic and time of travel. Our experienced drivers select the best highway routes to ensure smooth and comfortable long-distance travel.',
    },
    {
        id: 7,
        question: 'Is online payment available for Hadapsar to Navi Mumbai Airport Cab booking?',
        answer:
            'Yes, Skyline Cabs supports secure online payments including UPI, credit cards, debit cards, and net banking. Once your payment is completed, you receive instant confirmation along with trip and driver details for complete peace of mind.',
    },
    {
        id: 8,
        question: 'Can I pre-book Hadapsar to Navi Mumbai Airport Cab in advance?',
        answer:
            'Absolutely. You can pre-book your Hadapsar to Navi Mumbai Airport Cab for any future date and time. Advance booking ensures guaranteed vehicle availability, especially during peak travel seasons, holidays, and corporate travel rush.',
    },
    {
        id: 9,
        question: 'Is Hadapsar to Navi Mumbai Airport Cab suitable for family and corporate travel?',
        answer:
            'Yes, our Hadapsar to Navi Mumbai Airport Cab service is ideal for both family and corporate travel. Spacious vehicles, comfortable seating, ample luggage space, and professional drivers ensure a relaxed and stress-free airport transfer experience.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Hadapsar to Navi Mumbai Airport Cab?',
        answer:
            'Skyline Cabs is trusted for Hadapsar to Navi Mumbai Airport Cab service because of our punctual pickups, experienced chauffeurs, clean and comfortable vehicles, transparent pricing, and 24x7 customer support. We focus on delivering safe, reliable, and smooth airport transfers every time.',
    },
];

const someReviews = [
    {
        name: "Mr. Sachin More",
        rating: 5,
        review: "Booked Hadapsar to Navi Mumbai Airport Cab with Skyline Cabs for early morning flight. Driver was on time, vehicle was clean, and the ride was smooth. Highly reliable airport transfer service!"
    },
    {
        name: "Mrs. Kavita Sharma",
        rating: 4,
        review: "Very dependable Hadapsar to Navi Mumbai Airport Cab service. Transparent pricing and comfortable vehicle made our journey stress-free. Skyline Cabs provides excellent and professional service."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      
    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Navi Mumbai Cab",
  "image": "https://skylinecabs.com/assets/images/pune-to-navi-mumbai-cab.jpg",
  "description": "Book Pune to Navi Mumbai Cab with Skyline Cabs for comfortable, safe, and reliable travel. AC, Innova Crysta, Ertiga, and Sedan cabs available from all major Pune areas including Hadapsar, Hinjewadi, Wakad, Baner, Kharadi, and Pimpri Chinchwad with professional drivers at affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2599",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-to-navi-mumbai-cab"
  }
};

      


    return (
        <div>


<Helmet>
  <title>Pune to Navi Mumbai Cab | AC Car with Driver | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Navi Mumbai Cab with Skyline Cabs for safe, comfortable, and reliable travel. AC, Innova Crysta, Ertiga, and Sedan cabs available from all major Pune areas with professional drivers at affordable fares." 
  />
  <meta 
    name="keywords" 
    content="pune to navi mumbai cab, navi mumbai to pune cab, navi mumbai to pune taxi, navi mumbai to pune taxi fare, Pune to Navi Mumbai Cab, Pune to Navi Mumbai Taxi, Pune to Navi Mumbai Cabs, Cab from Pune to Navi Mumbai, Taxi from Pune to Navi Mumbai, Hadapsar to Navi Mumbai Cab, Hinjewadi to Navi Mumbai Cab, Wakad to Navi Mumbai Cab, Baner to Navi Mumbai Cab, Kharadi to Navi Mumbai Cab, Pimpri Chinchwad to Navi Mumbai Cab, Innova Crysta Pune to Navi Mumbai, Ertiga Cab Pune to Navi Mumbai, Sedan Cab Pune to Navi Mumbai, Skyline Cabs Pune to Navi Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/140.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetonavimumbaicab;